import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";

import { Check, Shield } from "@/components/landing/icons";
import { CoupDePouce, CourtageBox } from "@/components/landing/Offer";
import { Seo } from "@/components/landing/Seo";
import { FinalCta, KpiBand, LandingHero, LandingNav, Method, ReviewsFaq, SegmentCards, d, useReveal } from "@/components/landing/Sections";
import { segmentBySlug } from "@/pages/siteContent";

const FICHES = { "BAR-TH-179": "Pompe à chaleur collective air/eau en remplacement d'une chaudière, pour le résidentiel collectif.", "BAT-TH-163": "Pompe à chaleur air/eau pour le chauffage des bâtiments tertiaires." };

const Stakes = ({ seg }) => (
  <section id="enjeux" className="lp-section">
    <div className="lp-wrap lp-stakes">
      <div className="lp-bezel lp-rv"><div className="lp-core lp-stakebox">
        <span className="lp-eyebrow">Vos enjeux</span>
        <h2>Ce que nous entendons le plus <em>souvent</em></h2>
        <ol>{seg.stakes.map((t, i) => <li key={t}><span className={`lp-n lp-c${i}`}>{i + 1}</span>{t}</li>)}</ol>
      </div></div>
      <div className="lp-bezel lp-rv" style={d(120)}><div className="lp-core lp-stakebox lp-gainbox" data-testid="segment-benefits">
        <span className="lp-eyebrow">Ce que vous y gagnez</span>
        <h2>Un projet <em>financé</em>, sécurisé, piloté</h2>
        <ul>{seg.benefits.map((t) => <li key={t}><Check />{t}</li>)}</ul>
        <div className="lp-fichebox" data-testid="segment-fiche"><strong>{seg.fiche}</strong><p>{FICHES[seg.fiche]}</p><span><Shield />Dossier conforme au Pôle National CEE</span></div>
      </div></div>
    </div>
  </section>
);

export default function SegmentPage() {
  const { slug } = useParams();
  const seg = segmentBySlug(slug);
  useReveal(slug);
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  if (!seg) return <Navigate to="/" replace />;
  return (
    <div className="lp" data-testid={`segment-page-${seg.slug}`}>
      <Seo path={`/pompe-a-chaleur/${seg.slug}`} />
      <LandingNav />
      <LandingHero
        key={seg.slug} image={seg.image} alt={seg.alt} source={seg.slug} building={seg.buildingType}
        top={<Link to="/" className="lp-back" data-testid="segment-back"><ArrowLeft size={14} />Tous les bâtiments</Link>}
        eyebrow={`${seg.label} · Fiche ${seg.fiche}`}
        title={<span data-testid="segment-title">{seg.titleStart} <em>{seg.titleEm}</em>{seg.titleEnd}</span>}
        lead={seg.intro}
        proofs={["0 € de frais de courtage", "Prime CEE déduite du devis", "Installateurs RGE"]}
      />
      <KpiBand />
      <CourtageBox />
      <CoupDePouce kinds={[seg.fiche === "BAT-TH-163" ? "tertiaire" : "residentiel"]} />
      <Stakes seg={seg} />
      <Method image={seg.howImage} />
      <ReviewsFaq faq={seg.faq} title={<>Vos questions, nos <em>réponses</em></>} />
      <SegmentCards current={seg.slug} title={<>Tous les <em>bâtiments</em> que nous accompagnons</>} />
      <FinalCta image={seg.finalImage} source={seg.slug} />
    </div>
  );
}
